export default "__VITE_ASSET__zjWUFnHe__"